var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.2,
    height: 17.221,
    viewBox: "0 0 17.2 17.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration_default",
    "data-name": "Integration default",
    transform: "translate(-0.15 -0.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intergration",
    d: "M13.67,5.32a1.494,1.494,0,0,0-1.49-1.49",
    fill: "none",
    stroke: "#797f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intergration-2",
    d: "M12.18,3.83H9.21s-.08-.03-.08-.08h0V2.69A1.928,1.928,0,0,0,7.26.75,1.908,1.908,0,0,0,5.32,2.62V3.75s-.03.08-.08.08H2.27A1.519,1.519,0,0,0,.75,5.35V8.06s.03.08.08.08H1.86a2.157,2.157,0,0,1,.03,4.31H.83s-.08.03-.08.08v2.71a1.519,1.519,0,0,0,1.52,1.52H4.98s.08-.03.08-.08v-.8a2.2,2.2,0,0,1,2.12-2.19,2.038,2.038,0,0,1,2.19,1.87v1.13s.03.08.08.08h2.74a1.494,1.494,0,0,0,1.49-1.49v-3s.03-.08.08-.08h1.1a1.905,1.905,0,1,0-.03-3.81H13.76",
    fill: "none",
    stroke: "#797f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    cx: 0.41,
    cy: 0.41,
    r: 0.41,
    transform: "translate(14.8 6)",
    fill: "#797f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intergration-3",
    d: "M13.67,5.32a1.494,1.494,0,0,0-1.49-1.49",
    fill: "none",
    stroke: "#797f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intergration-4",
    d: "M13.67,12.26s.03-.08.08-.08h1.1a1.905,1.905,0,0,0-.03-3.81H13.75",
    fill: "none",
    stroke: "#797f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intergration-5",
    d: "M12.18,3.83H9.21s-.08-.03-.08-.08h0V2.69A1.928,1.928,0,0,0,7.26.75,1.908,1.908,0,0,0,5.32,2.62V3.75s-.03.08-.08.08H2.27A1.519,1.519,0,0,0,.75,5.35V8.06s.03.08.08.08H1.86a2.157,2.157,0,0,1,.03,4.31H.83s-.08.03-.08.08v2.71a1.519,1.519,0,0,0,1.52,1.52H4.98s.08-.03.08-.08v-.8a2.2,2.2,0,0,1,2.12-2.19,2.038,2.038,0,0,1,2.19,1.87v1.13s.03.08.08.08h2.74a1.494,1.494,0,0,0,1.49-1.49v-3",
    fill: "none",
    stroke: "#797f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152-2",
    cx: 0.41,
    cy: 0.41,
    r: 0.41,
    transform: "translate(14.8 6)",
    fill: "#797f88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationPrimaryIcon);
export default __webpack_public_path__ + "static/media/integration-primary-icon.4bd64a707cd487a16c11da2fe019529e.svg";
export { ForwardRef as ReactComponent };